var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFacebookNew = function SvgFacebookNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 6,
    fill: "#3479EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.7993C22.5 10.493 19.0302 7.00195 14.75 7.00195C10.4698 7.00195 7 10.493 7 14.7993C7 18.6912 9.83406 21.917 13.5391 22.502V17.0533H11.5713V14.7993H13.5391V13.0815C13.5391 11.1273 14.6961 10.0478 16.4663 10.0478C17.3143 10.0478 18.2012 10.2001 18.2012 10.2001V12.119H17.2239C16.2612 12.119 15.9609 12.72 15.9609 13.3367V14.7993H18.1104L17.7667 17.0533H15.9609V22.502C19.6659 21.917 22.5 18.6912 22.5 14.7993Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-new.95f691df.svg";
export { ForwardRef as ReactComponent };